// extracted by mini-css-extract-plugin
export default {"navLeft":"TextFooter_navLeft__ZfjTy","logoText":"TextFooter_logoText__IQscE"};